import React, { memo, useMemo } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import { selectDefaultCurrency } from 'reducers/selectors';
import RowAccount from '../RowAccount';
import AccountBalance from './AccountBalance';
import { isWeb } from '../../../../constants';
import RowEmmaInvestAccount from '../RowEmmaInvestAccount';
import RowPot from '../RowPot';
import UnopenedPotItem from '../UnopenedPotItem';
import UnopenedInvestmentAccountItem from '../UnopenedInvestmentAccountItem';
const AccountOverviewItem = (props) => {
    const styles = useStyles(styleSet);
    if ('title' in props) {
        return <AccountOverviewHeaderItem {...props}/>;
    }
    return (<View style={[
            styles.card,
            props.isLast && staticStyles.cardLast,
            props.isFirst && staticStyles.cardFirst,
        ]}>
      <AccountOverviewAccountItem {...props}/>
    </View>);
};
const AccountOverviewHeaderItem = ({ title, balanceColor, total, firstItem, forceShowBottomContent, isEmpty, firstCTA, onFirstCTAPress, secondCTA, onSecondCTAPress, }) => {
    const styles = useStyles(styleSet);
    const defaultCurrency = useAppSelector(selectDefaultCurrency);
    const currency = useMemo(() => {
        if (firstItem &&
            !('productName' in firstItem) &&
            !('investAccountName' in firstItem)) {
            if ('currency' in firstItem) {
                return firstItem.currency;
            }
            if ('primaryCurrencyBalance' in firstItem &&
                firstItem.primaryCurrencyBalance?.currency) {
                return firstItem.primaryCurrencyBalance?.currency;
            }
            if (firstItem.balance?.currency) {
                return firstItem.balance.currency;
            }
        }
        return defaultCurrency;
    }, [defaultCurrency, firstItem]);
    const titleBottomContent = useMemo(() => {
        if (isWeb) {
            return null;
        }
        if (!forceShowBottomContent) {
            if (!isEmpty) {
                return null;
            }
        }
        if (firstCTA && onFirstCTAPress) {
            const elements = [
                <TouchableOpacity key="firstCTA" onPress={onFirstCTAPress}>
          <Text TextThin-14 Primary>
            {firstCTA}
          </Text>
        </TouchableOpacity>,
            ];
            if (secondCTA && onSecondCTAPress) {
                elements.push(<Text key="or" TextThin-14 Gray>
            {' or '}
          </Text>);
                elements.push(<TouchableOpacity key="secondCTA" onPress={onSecondCTAPress}>
            <Text TextThin-14 Primary>
              {secondCTA}
            </Text>
          </TouchableOpacity>);
            }
            return <View style={staticStyles.callToActionRow}>{elements}</View>;
        }
        return null;
    }, [
        forceShowBottomContent,
        firstCTA,
        onFirstCTAPress,
        isEmpty,
        secondCTA,
        onSecondCTAPress,
    ]);
    return (<View style={[
            styles.headerContainer,
            isEmpty && [staticStyles.hideBorder, staticStyles.cardLast],
        ]}>
      <View style={staticStyles.titleRow}>
        <Text Text-16 OffBlack>
          {title}
        </Text>

        <AccountBalance color={balanceColor} currency={currency} amount={total}/>
      </View>
      {titleBottomContent}
    </View>);
};
const AccountOverviewAccountItem = (props) => {
    const { onRowPress, onOpenLogins, onOpenUpgrade, onRowLongPress, ...item } = props;
    if ('productName' in item) {
        return <UnopenedPotItem data={item}/>;
    }
    if ('investAccountName' in item) {
        return <UnopenedInvestmentAccountItem data={item}/>;
    }
    if ('currency' in item) {
        return (<RowAccount onCard data={item} style={staticStyles.row} onPress={onRowPress} onOpenLogins={onOpenLogins} onOpenUpgrade={onOpenUpgrade} onRowLongPressed={onRowLongPress} showHidden showGoal/>);
    }
    if ('isEmmaInvestmentAccount' in item) {
        return <RowEmmaInvestAccount onCard data={item} style={staticStyles.row}/>;
    }
    return <RowPot data={item}/>;
};
const styleSet = createStyleSheets((colors) => ({
    headerContainer: {
        backgroundColor: colors.cards.onDark,
        padding: rem(16),
        marginHorizontal: rem(16),
        borderTopLeftRadius: rem(16),
        borderTopRightRadius: rem(16),
        borderBottomWidth: rem(1),
        borderBottomColor: colors.background.dark,
    },
    card: {
        marginHorizontal: rem(16),
        backgroundColor: colors.cards.onDark,
        ...(isWeb && {
            padding: rem(8),
        }),
    },
}));
const staticStyles = StyleSheet.create({
    hideBorder: {
        borderBottomWidth: 0,
    },
    row: {
        paddingHorizontal: rem(16),
        ...(isWeb && {
            paddingHorizontal: rem(8),
        }),
    },
    titleRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    callToActionRow: {
        flexDirection: 'row',
    },
    cardLast: {
        marginBottom: rem(16),
        borderBottomLeftRadius: rem(16),
        borderBottomRightRadius: rem(16),
    },
    cardFirst: {
        borderTopLeftRadius: rem(16),
        borderTopRightRadius: rem(16),
    },
});
export default memo(AccountOverviewItem);
